import { Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import SimTypeChip from 'utils/SimTypeChip';
import { getDeviceDetails } from './data/DetailPurchase';
import { getAdvancedTransactionDetails } from './data/DetailsHistoryPrepaid';
import { getTransactionMPDetails } from './data/DetailsMercadoPago';
import { getSecurityDetails } from './data/DetailsNetPay';
import { getTransactionDetails } from './data/DetailsOpenPay';
import { getPurchaseSummaryAiralo } from './data/DetailsPurchaseAiralo';
import { getDateDetails } from './data/DetailsSimIpb';
import { getTransactionDetailsSTP } from './data/DetailsSTP';
import { getStripeTransactions } from './data/DetailsStripe';
import { getTransactionDetailsToku } from './data/DetailsToku';
import { getYunoTransactions } from './data/DetailsYuno';

const titleStyle = { color: '#7A3C92' };
const spanStyle = { fontSize: 15, wordWrap: 'break-word' };
const valueStyle = {
  textAlign: 'right',
  marginTop: '8px',
  wordWrap: 'break-word',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};

const OrderAdditionalInfo = ({ orderDetails, title, type, labelSimType }) => {
  let items = [];

  if (type === 'detailsSTP') {
    items = getTransactionDetailsSTP(orderDetails);
  } else if (type === 'detailsToku') {
    items = getTransactionDetailsToku(orderDetails);
  } else if (type === 'detailsNetPay') {
    items = getSecurityDetails(orderDetails);
  } else if (type === 'detailsHistoryPrepaid') {
    items = getAdvancedTransactionDetails(orderDetails);
  } else if (type === 'detailsSimIpb') {
    items = getDateDetails(orderDetails);
  } else if (type === 'detailPurchase') {
    items = getDeviceDetails(orderDetails);
  } else if (type === 'detailsOpenPay') {
    items = getTransactionDetails(orderDetails);
  } else if (type === 'detailsMercadoPago') {
    items = getTransactionMPDetails(orderDetails);
  } else if (type === 'detailsStripe') {
    items = getStripeTransactions(orderDetails[0]);
  } else if (type === 'detailsYuno') {
    items = getYunoTransactions(orderDetails[0]);
  } else if (type === 'AiraloDetails') {
    items = getPurchaseSummaryAiralo(orderDetails);
  }

  return (
    <Grid container className='device-info' size={{ xs: 12 }}>
      <Grid item size={{ xs: 12 }}>
        <span style={titleStyle}>{title}</span>
      </Grid>
      {items.map((item, index) => (
        <Grid container key={index} size={{ xs: 12 }}>
          {item.label === 'Pago multiple MP' ? (
            <>
              <hr style={{ borderColor: '#800080a3' }} />
              <Grid item size={{ xs: 12 }}>
                <span style={spanStyle}>{`Pago ${item.value}`}</span>
              </Grid>
            </>
          ) : (
            <>
              <Grid item size={{ xs: 6 }}>
                <span style={spanStyle}>{item.label}:</span>
              </Grid>
              <Grid item size={{ xs: 6 }} style={valueStyle}>
                <Typography variant='body1'>{item.value || 'N/A'}</Typography>
              </Grid>
            </>
          )}
        </Grid>
      ))}
      {type === 'detailPurchase' && (
        <Grid container size={{ xs: 12 }}>
          <Grid item size={{ xs: 6 }}>
            <span style={spanStyle}>Tipo de SIM:</span>
          </Grid>
          <Grid item size={{ xs: 6 }} style={valueStyle}>
            <Typography variant='body1'>
              <SimTypeChip simTypeName={Number(labelSimType?.sim_type_id)} />
            </Typography>
          </Grid>
        </Grid>
      )}
    </Grid>
  );
};

export default OrderAdditionalInfo;
